import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
	  path: '/',
	  redirect: 'styleMap'
	  }, {
      path: '/styleMap',
      name: 'styleMap',
      component: resolve => require(['../components/createMap/styleMap/styleMap.vue'], resolve)
    }, {
      path:'/createMap',
      name:'createMap',
      component: resolve => require(['../components/createMap/create/CreateMap.vue'], resolve)
    }, /*{
      path: '/resourceRel',
      name: 'resourceRel',
       component: resolve => require(['../components/resourcerelmanage/Index.vue'], resolve)
    }, */{
      path:'/showMap/:mapId',
      name:'showMap',
      component: resolve => require(['../components/createMap/showMap/ShowMap.vue'], resolve)
    }, {
      path:'/editMap/:mapId',
      name:'editMap',
      component: resolve => require(['../components/createMap/create/CreateMap.vue'], resolve)
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: resolve => require(['../components/createMap/pdf/pdf.vue'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js